import { MerchantInvoiceState } from 'modules/invoice/stores/preview-merchant.store'
import { GenericState } from 'stores/generics'
import { STORE_STATUS_INITIALIZED, STORE_STATUS_LOADING } from 'constants/store'

export const STORE_INVOICE_FETCH_PREVIEW_BUYER_MOCK_INITIALIZED: GenericState<MerchantInvoiceState> =
  {
    data: {
      status: 'pending',
      short_id: '',
      buyer_company_id: '',
      buyer_name: '',
      seller_company_id: '',
      seller_name: '',
      deal_conditions: [],
      id: '',
      due_date: '',
      description: '',
      created_at: '',
      amount_cents: 0,
      original_amount_cents: 0,
      merchant_service_fee_amount_cents: 0,
      installments: 0,
      invoice_installments: [],
      line_items: [],
      nfe_download_token: '',
      external_id: '',
    },
    status: STORE_STATUS_INITIALIZED,
    error: null,
  }

export const STORE_INVOICE_FETCH_PREVIEW_BUYER_MOCK_LOADING: GenericState<MerchantInvoiceState> =
  {
    ...STORE_INVOICE_FETCH_PREVIEW_BUYER_MOCK_INITIALIZED,
    status: STORE_STATUS_LOADING,
  }
